module.exports = {
  ADD_MESSAGE: 'ADD_MESSAGE'
}
